// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2QKDY","footer":"Form_footer__5GdTe"};